import { render, staticRenderFns } from "./planosMensaisInfantil.vue?vue&type=template&id=5fbf000c"
import script from "./planosMensaisInfantil.vue?vue&type=script&lang=js"
export * from "./planosMensaisInfantil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports